<div class="continer" [id]="data?.details?.id">
  <h3 class="text-center" *ngIf="data?.details.title">
    {{ data.details.title.split(" ")[0] }}
    <span> {{ data.details.title.split(" ").slice(1).join(" ") }}</span>
  </h3>
  <div
    class="row mt-3 m-0 justify-content-center"
    *ngFor="let item of data.details.services"
  >
    <img
      class="col-12 col-md-5 text-center p-0 img-fluid"
      [src]="item.imageIconPath"
      [alt]="item.imageAlt"
    />

    <div class="col-12 col-md-7 my-auto px-4">
      <h1>{{ item.titleTr }}</h1>
      <h5 class="mb-4 description" [innerHTML]="item.summary"></h5>
      <a
        class="btn"
        [href]="getDetailsUrl(item)"
        *ngIf="data.details.isDetails"
        >{{ "details" | translate }}</a
      >
    </div>
  </div>
</div>
